import React from 'react'
import type { FC } from 'react'
interface Props {
  className?: string;
  color?: string;
  size?: number | string;
  rotateOnRtl?: boolean;
}
export const IconMicrowave: FC<Props> = ({
  color = 'currentColor',
  size = 24,
  className,
  rotateOnRtl = false,
  ...rest
}) => {
  const props = {
    width: size,
    height: size,
    fill: color,
    // stroke: color,
    className,
    viewBox: '0 0 24 24',
    ['data-rotateonrtl']: false,
    ...rest,
  }
  return /*#__PURE__*/ React.createElement(
    'svg',
    Object.assign(
      {
        xmlns: 'http://www.w3.org/2000/svg',
        width: 24,
        height: 24,
        viewBox: '0 0 24 24',
      },
      props
    ),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M3 4h18c.6 0 1 .4 1 1v13c0 .6-.4 1-1 1h-2v1c0 .6-.4 1-1 1s-1-.4-1-1v-1H7v1c0 .6-.4 1-1 1s-1-.4-1-1v-1H3c-.6 0-1-.4-1-1V5c0-.6.4-1 1-1zm1 2v11h10V6H4zm12 0v11h4V6h-4zm3 7a1 1 0 11-2 0 1 1 0 012 0zm-1-3a1 1 0 100-2 1 1 0 000 2zM7 13h4c.6 0 1 .4 1 1s-.4 1-1 1H7c-.6 0-1-.4-1-1s.4-1 1-1z',
      fillRule: 'evenodd',
      clipRule: 'evenodd',
    })
  )
}
